import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[customTooltip]',
})
export class CustomTooltipDirective {
  @Input('customTooltip')
  tooltipText: string = 'You do not have permission to access this feature.';

  @Input()
  showTooltip: boolean = true;

  private tooltipElement!: HTMLElement;
  private arrowElement!: HTMLElement;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.showTooltip) {
      return;
    }

    const message = this.tooltipText?.trim() || 'You do not have permission to access this feature.';

    // Tooltip container
    this.tooltipElement = this.renderer.createElement('div');

    this.renderer.setProperty(this.tooltipElement, 'innerHTML', message);

    // Tooltip styles
    this.renderer.setStyle(this.tooltipElement, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipElement, 'background', '#000');
    this.renderer.setStyle(this.tooltipElement, 'color', '#fff');
    this.renderer.setStyle(this.tooltipElement, 'padding', '5px 8px');
    this.renderer.setStyle(this.tooltipElement, 'border-radius', '6px');
    this.renderer.setStyle(this.tooltipElement, 'font-size', '12px');
    this.renderer.setStyle(this.tooltipElement, 'white-space', 'nowrap');
    this.renderer.setStyle(this.tooltipElement, 'z-index', '9999');
    this.renderer.setStyle(this.tooltipElement, 'pointer-events', 'none');
    this.renderer.setStyle(this.tooltipElement, 'text-align', 'center');

    // Arrow element
    this.arrowElement = this.renderer.createElement('div');

    this.renderer.setStyle(this.arrowElement, 'position', 'absolute');
    this.renderer.setStyle(this.arrowElement, 'bottom', '-6px');

    // Dynamic arrow position
    this.renderer.setStyle(this.arrowElement, 'width', '0');
    this.renderer.setStyle(this.arrowElement, 'height', '0');

    this.renderer.setStyle(this.arrowElement, 'border-left', '6px solid transparent');

    this.renderer.setStyle(this.arrowElement, 'border-right', '6px solid transparent');

    this.renderer.setStyle(this.arrowElement, 'border-top', '6px solid #000');

    // Append arrow
    this.renderer.appendChild(this.tooltipElement, this.arrowElement);

    document.body.appendChild(this.tooltipElement);

    const rect = this.el.nativeElement.getBoundingClientRect();

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    // Tooltip position
    const tooltipTop = rect.top + scrollTop - 40;

    const tooltipLeft = rect.left + scrollLeft + rect.width / 2 - this.tooltipElement.offsetWidth / 2;

    this.renderer.setStyle(this.tooltipElement, 'top', `${tooltipTop}px`);

    this.renderer.setStyle(this.tooltipElement, 'left', `${tooltipLeft}px`);

    // ===== Dynamic arrow alignment =====

    const elementCenter = rect.left + rect.width / 2 + scrollLeft;

    const tooltipStart = tooltipLeft;

    const arrowLeft = elementCenter - tooltipStart - 6;

    this.renderer.setStyle(this.arrowElement, 'left', `${arrowLeft}px`);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.removeTooltip();
  }

  private removeTooltip() {
    if (this.tooltipElement) {
      this.tooltipElement.remove();
    }
  }
}
